import * as BILL_METHOD from '../constants/BillMethod';
import { isNil } from 'lodash';
import {
  INVENTORY_MAINTENANCE_TYPES,
  MERCHANDISE_TYPES
} from './util-constants';

const rentalPrice = {
  isVisible: (billMethod) => billMethod !== BILL_METHOD.PieceRateOnly
};

const priceRental = rentalPrice;

const washPrice = {
  isVisible: (billMethod, value) =>
    billMethod === BILL_METHOD.CirculatingInventory ||
    (billMethod === BILL_METHOD.PieceRateOnly && value != null)
};

const priceWash = washPrice;

const priceReplace = {
  isVisible: (billMethod) => billMethod !== BILL_METHOD.PieceRateOnly
};

const replacePrice = priceReplace;

const priceItem = {
  isVisible: (billMethod, value) =>
    billMethod === BILL_METHOD.PieceRateOnly && value != null
};

const itemPrice = priceItem;
const salesPrice = priceItem;
const salePrice = priceItem;

const quantity = {
  isVisible: (billMethod) =>
    billMethod === BILL_METHOD.FlatRatedRent ||
    billMethod === BILL_METHOD.PieceRateOnly ||
    billMethod === BILL_METHOD.WeeklyUsage
};

const rentalQuantity = quantity;

const inventoryMaintenance = {
  isVisible: (billMethod, value, typeOfMerchandise) =>
    typeOfMerchandise.toUpperCase() !== MERCHANDISE_TYPES.GARMENTS &&
    value.toUpperCase() !== INVENTORY_MAINTENANCE_TYPES.NO_SRC
};

const weeklyUsage = {
  isVisible: (billMethod) => 
    billMethod === BILL_METHOD.WeeklyUsage
};

const easyCarePrice = {
  isVisible: (billMethod, value, typeOfMerchandise) => true
};

const numberOfWearers = {
  isVisible: (billMethod, value, typeOfMerchandise) =>
    typeOfMerchandise.toUpperCase() === MERCHANDISE_TYPES.GARMENTS
};

const numberOfItemsPerWearer = {
  isVisible: (billMethod, value, typeOfMerchandise) =>
    typeOfMerchandise.toUpperCase() === MERCHANDISE_TYPES.GARMENTS
};

const minUsePercentage = {
  isVisible: (billMethod) => billMethod === BILL_METHOD.RentBasedOnMinimum
};

const deliveryQuantity = {
  isVisible: (billMethod) => true
};

const DEFAULT = {
  isVisible: (billMethod) => true
};

const isVisibles = {
  rentalPrice,
  priceRental,
  washPrice,
  priceWash,
  priceReplace,
  replacePrice,
  priceItem,
  itemPrice,
  salesPrice,
  salePrice,
  quantity,
  rentalQuantity,
  inventoryMaintenance,
  weeklyUsage,
  easyCarePrice,
  numberOfWearers,
  numberOfItemsPerWearer,
  minUsePercentage,
  deliveryQuantity
};

const isFieldVisible = (field, billMethod, value, typeOfMerchandise) =>
  !isNil(value) &&
  (Object.keys(isVisibles).includes(field)
    ? isVisibles[field].isVisible(billMethod, value, typeOfMerchandise)
    : DEFAULT.isVisible(billMethod));

export { isFieldVisible };
